import React from "react";
import {
    any,
    arrayOf,
    bool,
    number,
    oneOfType,
    shape,
    string,
} from "prop-types";
import { Input, Label, Radio, Text } from "theme-ui";
import { Stack } from "@bedrock-layout/stack";

const InputFactory = ({
    defaultValue,
    disabled,
    error,
    label,
    name,
    options = {},
    register,
    rest,
    type,
    variant,
}) => {
    const errorMsg = error && error.message;
    const inputVariant = errorMsg ? "input.error" : variant ? variant : "input";

    const renderInput = () => {
        if (type === "radio" && Array.isArray(options) && options.length) {
            return options.map((option) => (
                <Label key={option.value}>
                    <Radio
                        value={option.value}
                        disabled={disabled}
                        readOnly={disabled}
                        variant={inputVariant}
                        {...rest}
                        {...register(name)}
                    />
                    {option.label}
                </Label>
            ));
        }
        return (
            <Input
                type={type}
                disabled={disabled}
                readOnly={disabled}
                defaultValue={defaultValue}
                variant={inputVariant}
                {...rest}
                {...register(name)}
            />
        );
    };

    return (
        <Stack gutter="md">
            <Text variant="label">{label}</Text>
            {renderInput()}
            {errorMsg && (
                <Text variant="primary" color={errorMsg ? "errorText" : null}>
                    {errorMsg}
                </Text>
            )}
        </Stack>
    );
};

InputFactory.propTypes = {
    defaultValue: oneOfType([string, number]),
    disabled: bool,
    error: any,
    label: string,
    name: string,
    options: arrayOf(
        shape({
            value: string,
            label: string,
        })
    ),
    register: any,
    required: bool,
    rest: any,
    type: string,
    variant: string,
};

export default InputFactory;
